import React from "react";
import ContentLoader from "react-content-loader";

const RoadMapLoader = () => (
    <div className="single-timeline-area">
    {/* Loading skeleton for the timeline-date */}
    <div className="timeline-date wow fadeInLeft" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInLeft" }}>
      <ContentLoader
        speed={2}
        width={300}
        height={40}
        viewBox="0 0 300 40"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="10" rx="4" ry="4" width="200" height="15" />
      </ContentLoader>
    </div>

    {/* Repeat loader for other parts of the timeline */}
    <div className="row">
      <div className="col-12 col-md-6 col-lg-4">
        <ContentLoader
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <circle cx="25" cy="25" r="20" />
          <rect x="60" y="10" rx="4" ry="4" width="200" height="15" />
          <rect x="60" y="30" rx="4" ry="4" width="150" height="15" />
          <rect x="60" y="60" rx="4" ry="4" width="120" height="20" />
          <rect x="60" y="90" rx="4" ry="4" width="100" height="15" />
        </ContentLoader>
      </div>

      {/* Repeat loader for other items */}
      <div className="col-12 col-md-6 col-lg-4">
        <ContentLoader
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <circle cx="25" cy="25" r="20" />
          <rect x="60" y="10" rx="4" ry="4" width="200" height="15" />
          <rect x="60" y="30" rx="4" ry="4" width="150" height="15" />
          <rect x="60" y="60" rx="4" ry="4" width="120" height="20" />
          <rect x="60" y="90" rx="4" ry="4" width="100" height="15" />
        </ContentLoader>
      </div>

      <div className="col-12 col-md-6 col-lg-4">
        <ContentLoader
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <circle cx="25" cy="25" r="20" />
          <rect x="60" y="10" rx="4" ry="4" width="200" height="15" />
          <rect x="60" y="30" rx="4" ry="4" width="150" height="15" />
          <rect x="60" y="60" rx="4" ry="4" width="120" height="20" />
          <rect x="60" y="90" rx="4" ry="4" width="100" height="15" />
        </ContentLoader>
      </div>
    </div>


    <div className="row">
      <div className="col-12 col-md-6 col-lg-4">
        <ContentLoader
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <circle cx="25" cy="25" r="20" />
          <rect x="60" y="10" rx="4" ry="4" width="200" height="15" />
          <rect x="60" y="30" rx="4" ry="4" width="150" height="15" />
          <rect x="60" y="60" rx="4" ry="4" width="120" height="20" />
          <rect x="60" y="90" rx="4" ry="4" width="100" height="15" />
        </ContentLoader>
      </div>

      {/* Repeat loader for other items */}
      <div className="col-12 col-md-6 col-lg-4">
        <ContentLoader
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <circle cx="25" cy="25" r="20" />
          <rect x="60" y="10" rx="4" ry="4" width="200" height="15" />
          <rect x="60" y="30" rx="4" ry="4" width="150" height="15" />
          <rect x="60" y="60" rx="4" ry="4" width="120" height="20" />
          <rect x="60" y="90" rx="4" ry="4" width="100" height="15" />
        </ContentLoader>
      </div>

      <div className="col-12 col-md-6 col-lg-4">
        <ContentLoader
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <circle cx="25" cy="25" r="20" />
          <rect x="60" y="10" rx="4" ry="4" width="200" height="15" />
          <rect x="60" y="30" rx="4" ry="4" width="150" height="15" />
          <rect x="60" y="60" rx="4" ry="4" width="120" height="20" />
          <rect x="60" y="90" rx="4" ry="4" width="100" height="15" />
        </ContentLoader>
      </div>
    </div>
  </div>

  

);

export default RoadMapLoader;
